import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a94cc83e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup-intro" }
const _hoisted_2 = { class: "signup-intro__inner" }
const _hoisted_3 = { class: "signup-intro__title" }

import { useI18n } from 'vue-i18n'

import SignupIntroContact from '@C/pages/signup/SignupIntro/SignupIntroContact.vue'
import SignupIntroSecurity from '@C/pages/signup/SignupIntro/SignupIntroSecurity.vue'
import SignupIntroSteps from '@C/pages/signup/SignupIntro/SignupIntroSteps.vue'
import AppLogoWhite from '@C/ui/icons/AppLogoWhite.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SignupIntro',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppLogoWhite, { class: "signup-intro__logo" }),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)('signupPage.titleExtendedDesktop')), 1),
      _createVNode(SignupIntroSteps, { class: "signup-intro__steps" }),
      _createVNode(SignupIntroSecurity, { class: "signup-intro__security" }),
      _createVNode(SignupIntroContact)
    ])
  ]))
}
}

})